<template>

<div style="display: flex; align-items: flex-start;">

	<div style="width:100px; margin-right: 20px;">
		
		<div class="btn btn-default dropzone-area" style="width:100px; margin-bottom:18px;">
			<div class="dropzone-response" v-if="procentage == null && dropzoneResponse == null">
	    		Välj fil: 
	    	</div>
	    	<div class="dropzone-response" v-if="procentage != null && dropzoneResponse == null">
	    		Laddar {{ procentage }}%
			</div>
			<div class="dropzone-response" v-if="dropzoneResponse != null">
	    	Välj fil: 
			</div>
			<input type="file" v-on:change="uploadFile" style="">
		</div>


		<div class="btn-group" v-if="currentFile != null">
			<button type="button" style="width:100px; border: 1px solid #ccc;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-primary btn-xs dropdown-toggle">
	        	Versioner <span class="caret"></span>
	        </button>

	        <ul class="dropdown-menu file-menu">
	        	<div style="padding:8px 12px; border-bottom: 1px solid #eee;"><b>Tidigare versioner:</b></div>
	        	<div class="file-menu-row" style="display:flex;" v-for="file in fileHistory">

	        		<div>
		        		<a v-bind:href="file.url" target="_blank">
			        		<img src="/images/admin/file_pdf.svg" v-if="fileExtension(file.original_name) == 'pdf'">
			                <img src="/images/admin/file_img.svg" v-else>
			            </a>
			        </div>

			        <div>
						<a v-bind:href="file.url" target="_blank"><div class="meta-file-title">{{ file.original_name }}</div></a>
						<div class="meta-file-date">{{ file.created_at.substr(0, 10) }}</div>
					</div>

	        	</div>
	        	
	        </ul>

	    </div>

	</div>


	<div style="display:flex; width:calc(100% - 120px); flex-wrap: wrap;" v-if="currentFile != null">
        <div class="meta-file-wrapper single">
            
            <div class="meta-file">
                <a :href="currentFile.url" target="_blank">
                    <img src="/images/admin/file_pdf.svg" v-if="fileExtension(currentFile.original_name) == 'pdf'">
                    <img src="/images/admin/file_img.svg" v-else>
                    <div class="meta-file-title">{{ currentFile.original_name }}</div>
                </a>
                <div class="meta-file-date">{{ currentFile.created_at.substr(0, 10) }}</div>
            </div>

        </div>
    </div>

	



	



</div>

</template>


<script>
    export default {
        props: {
	        type: {
	            
	        },
	        clinicId: {
	            
	        },
	        currentData: {

	        }
	    },
	    data: function() {

            return {

                dropzoneResponse: null,
                procentage: null,
               
            }

        },
	    methods: {
	 
	    	uploadFile: function(e) {

	    		var self = this;

	    		var fileUploadFormData = new FormData();

	    		self.dropzoneResponse = null;
	    		self.procentage = null;

	  			fileUploadFormData.append('file', e.target.files[0]);
	  			fileUploadFormData.append('type', self.type);
	  			fileUploadFormData.append('clinicId', self.clinicId);
	  			fileUploadFormData.append('meta_id', self.currentData.id);


			    self.$http.post('/clinics/upload',  fileUploadFormData, {

					progress: (e) => {
						self.procentage = Math.round((e.loaded/e.total)*100)
					}
				
				}).then((response) => {

                    console.log(response.body);

                    var file_id = response.body;

                   // self.allFiles = response.body;

                    self.dropzoneResponse = e.target.files[0].name;

                    bus.$emit('uploaded-file', self.type, file_id)


                }, (response) => {
                    console.log(JSON.stringify(response));
                });
	    	

	    	},

	    	fileExtension(filename) {
            	return filename.slice(filename.lastIndexOf('.') + 1);
        	}

	    },
	    computed: {

	    	currentFile: function() {

	 			//console.log('run current file');
	    		//console.log(this.allFiles);

	    		if(!this.allFiles || this.allFiles.length == 0) {
	    			//console.log('return empty shit');
	    			return null;
	    		}

	    		return this.allFiles[0];

	    	},

	    	fileHistory: function() {

	    		//console.log('run history');
	    		//console.log(this.allFiles);

	    		if(!this.allFiles || this.allFiles.length == 0) {
	    			//console.log('return empty thing');
	    			return null;
	    		}

	    		//console.log(this.allFiles);

	    		var history = _.drop(this.allFiles);
	    		
	    		//console.log(this.allFiles);

	    		return history;

	    	},

	    	allFiles: function() {

	    		console.log('watching currentFiles');
	    		console.log(this.currentFiles);

	    		if(!this.currentData) {

	    			return null;

	    		}

	    		return this.currentData.files;

	    		console.log('all files after update');
	    		console.log(this.allFiles);


	    	}

	    },
	    watch: {

	    	currentData: function() {

	    		/*
	    		console.log('watching currentFiles');
	    		console.log(this.currentFiles);

	    		if(!this.currentData) {

	    			return null;

	    		}

	    		this.allFiles = this.currentData.files;

	    		console.log('all files after update');
	    		console.log(this.allFiles);
	    		*/

	    	}


	    }

    }
</script>

<style type="text/scss">

	.dropzone-area {

	    text-align: center;
	    position: relative;
	    border: 2px dashed #CBCBCB;
	    cursor: pointer;
  	}

	.dropzone-area input {
	    position: absolute;
	    cursor: pointer;
	    top: 0px;
	    right: 0;
	    bottom: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    opacity: 0;
	}

</style>